import Solution from "./solution";
import compare from "../../Utils/compare";

const testCases = [
  {
    arr: [1, 2, [3, 4]],
    depth: 1,
  },
  {
    arr: [1, 2, [3, 4], [[5, [6, [7]]]]],
    depth: Infinity,
  },
  {
    arr: [
      [[1, [1.1]], 2, 3],
      [4, 5],
    ],
    depth: 2,
  },
  {
    arr: [1, 2, 3, 5, 6],
    depth: 2,
  },
  {
    arr: [[], 1, 2, 3, [4, 5]],
    depth: 1,
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { arr, depth } = test;
      let outcome1 = output()(arr, depth);
      let outcome2 = Solution(arr, depth);
      const result = compare(outcome1, outcome2);
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
